import { watch, ref } from '@vue/composition-api';

export const useFilterable = ({ listRef, key, filterRef }) => {
  const filteredList = ref([]);

  watch([listRef, filterRef], () => {
    if (filterRef.value === '') {
      filteredList.value = listRef.value;
      return;
    }
    const filter = filterRef.value.toLowerCase();
    filteredList.value = listRef.value.filter(
      (item) => item[key].toLowerCase().indexOf(filter) !== -1
    );
  });

  return filteredList;
};
